import { ProductJsonLd } from 'next-seo'

import { useTonMachines } from '@/contexts/machines'
import { getAssetURL } from '@/utils/getAssetURL'

export const pagesNamesForProductsDataForSEOPurposes = [
  'maquininha/t1',
  'maquininha/t2',
  'maquininha/t3',
  'maquininha/t3-smart'
]

export default function ProductData({ pageName }: { pageName: string }) {
  const { machinesDetailsByRefID, machinesByCatalog } = useTonMachines()

  const machineRefID = pageName
    .replace('maquininha/', '')
    .replace('-', '_')
    .toLocaleUpperCase()

  const allMachines = Array.from(machinesByCatalog.values()).flatMap(
    (item) => item
  )

  const machineOffers = allMachines.filter(
    (machine) => machine.refID === machineRefID
  )

  const [firstMachineOffer] = machineOffers

  const machineDetails = machinesDetailsByRefID.get(machineRefID)

  if (!machineDetails || !firstMachineOffer) return null

  const imageName = machineDetails.image.front
  const machinePopularName = machineDetails.name

  // TODO: pass more images in lower resolutions as we do before
  return (
    <ProductJsonLd
      productName={machinePopularName}
      images={[getAssetURL(`ton-cms/prd/${imageName}.png`)]}
      description={firstMachineOffer.title}
      color="#00AD0C"
      offers={machineOffers.map((plan) => ({
        price: plan.amount,
        priceCurrency: 'BRL',
        itemCondition: 'https://schema.org/NewCondition',
        availability: 'https://schema.org/OnlineOnly',
        url: `https://ton.com.br/${pageName}`,
        priceValidUntil: '',
        seller: {
          type: 'Organization',
          name: 'Stone.Co'
        }
      }))}
    />
  )
}
